import React from "react";
import { Link } from "@/components/common/Link";
import { DraftingCompass, ChevronRight, House } from "lucide-react";
import { Breadcrumb, BreadcrumbList, BreadcrumbItem, BreadcrumbLink, BreadcrumbSeparator, BreadcrumbPage } from "@/components/ui/breadcrumb";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourProject() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="start-your-project" ref={ref} className={`relative w-full py-16 md:py-24 lg:py-32 bg-background overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute bottom-[10%] left-[5%] w-[30%] h-[30%] rounded-full bg-secondary/5 blur-[80px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {}
          <div className="flex flex-col items-start space-y-6 max-w-2xl">
            {}
            <Breadcrumb className="mb-2">
              <BreadcrumbList>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to="/HomePage" className="flex items-center gap-1">
                      <House className="h-3.5 w-3.5" />
                      House
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator>
                  <ChevronRight className="h-3.5 w-3.5" />
                </BreadcrumbSeparator>
                <BreadcrumbItem>
                  <BreadcrumbPage>Request Quote</BreadcrumbPage>
                </BreadcrumbItem>
              </BreadcrumbList>
            </Breadcrumb>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground leading-[1.1]">
              Request Your <span className="text-primary">Expert Assessment</span>
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-lg">
              Get a custom-tailored sealing plan for your property. We analyze your specific needs to provide durable, long-term protection.
            </p>
          </div>

          {}
          <div className="flex justify-center lg:justify-end items-center relative">
            <div className="relative group">
              {}
              <div className="absolute inset-0 bg-primary/10 rounded-full scale-150 blur-2xl group-hover:bg-primary/15 transition-all duration-500" />
              <div className="absolute inset-0 border border-primary/20 rounded-full scale-125 animate-[spin_10s_linear_infinite]" />
              <div className="absolute inset-0 border border-dashed border-muted-foreground/30 rounded-full scale-110 animate-[spin_15s_linear_infinite_reverse]" />
              
              {}
              <div className="relative bg-card border border-border shadow-2xl rounded-3xl p-10 flex items-center justify-center aspect-square w-64 h-64 md:w-80 md:h-80 backdrop-blur-sm bg-card/80">
                <DraftingCompass className="w-32 h-32 md:w-40 md:h-40 text-primary stroke-[1.5]" aria-hidden="true" />
                
                {}
                <div className="absolute -bottom-4 -right-4 bg-secondary text-secondary-foreground px-4 py-2 rounded-lg shadow-lg text-sm font-medium flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                  Ready to Plan
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}